import { render, staticRenderFns } from "./SmaNatconMemberRegistrationCreate.vue?vue&type=template&id=5114f059&scoped=true"
import script from "./SmaNatconMemberRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./SmaNatconMemberRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./SmaNatconMemberRegistrationCreate.vue?vue&type=style&index=0&id=5114f059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5114f059",
  null
  
)

export default component.exports